<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="cashInflowInstallments"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    :itemClass="itemClasses"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    id="cashInflowPrintTable"
  >

    <template slot="print">
      <BasePrintPdf
        :pdfTitle="modelNamePlural"
        @pdf-open-action="(f) => loadPdf(f)"
        ref="cashInflowPdfRef"
      />
    </template>

    <!-- <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
      />
    </template> -->

    <template slot="link1" slot-scope="{ item }">
      <PurchaseEdit
        v-if="item.parentType == 'Purchase'"
        :entry="item.parentObject"
        :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
        :readOnly="true"
        :isTextButton="true"
        :textButton="item.operationTypeText + ' ' + item.parentObject.code"
      />
      <SaleEdit
        v-else-if="item.parentType == 'Sale'"
        :entry="item.parentObject"
        :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
        :readOnly="true"
        :isTextButton="true"
        :textButton="item.operationTypeText + ' ' + item.parentObject.code"
      />
      <ServiceProvisionEdit
        v-else-if="item.parentType == 'ServiceProvision'"
        :entry="item.parentObject"
        :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
        :readOnly="true"
        :isTextButton="true"
        :textButton="item.operationTypeText + ' ' + item.parentObject.code"
      />
      <CashInflowEdit
        v-else-if="item.parentType == 'CashInflow'"
        :entry="item.parentObject"
        :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
        :readOnly="true"
        :isTextButton="true"
        :textButton="item.operationTypeText + ' ' + item.parentObject.code"
      />
      <CashOutflowEdit
        v-else-if="item.parentType == 'CashOutflow'"
        :entry="item.parentObject"
        :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
        :readOnly="true"
        :isTextButton="true"
        :textButton="item.operationTypeText + ' ' + item.parentObject.code"
      />
      <DepositEdit
        v-else-if="item.parentType == 'Deposit'"
        :entry="item.parentObject"
        :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
        :readOnly="true"
        :isTextButton="true"
        :textButton="item.operationTypeText + ' ' + item.parentObject.code"
      />
      <TransferEdit
        v-else-if="item.parentType == 'Transfer'"
        :entry="item.parentObject"
        :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
        :readOnly="true"
        :isTextButton="true"
        :textButton="item.operationTypeText + ' ' + item.parentObject.code"
      />
      <WithdrawEdit
        v-else-if="item.parentType == 'Withdraw'"
        :entry="item.parentObject"
        :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
        :readOnly="true"
        :isTextButton="true"
        :textButton="item.operationTypeText + ' ' + item.parentObject.code"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'pending_payment'">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :editOnly="true"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="item.status == 'Pendente'">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <!-- <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
      />
    </template> -->

    <template slot="action1" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'pending_payment'">
      <PaymentConfirmation
        :entry="item"
        @entry-updated="entryUpdated"
        @entry-canceled="loadServerEntries()"
      />
    </template>

    <!-- <template slot="action2" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'paid'">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :readOnly="true"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template> -->

    <template slot="action3" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'paid'">
      <PaymentCancellation
        :entry="item"
        @entry-destroyed="entryDeleted"
        @entry-canceled="loadServerEntries()"
      />
    </template>

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="7" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="2" class="text-left title"><strong>{{ this.installmentsTotalValue | formatCurrency }}</strong></td>
        <td colspan="3" class="text-left title"><strong>{{ this.installmentsTotalPaidAmount | formatCurrency }}</strong></td>
      </tr>
      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total das Parcelas</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.installmentsTotalValue | formatCurrency }}</strong></div>
        </td>
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total Recebido</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.installmentsTotalPaidAmount | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import PaymentCancellation from "@models/installments/cash_inflow_installments/payment_cancellation.vue";
import PaymentConfirmation from "@models/installments/cash_inflow_installments/payment_confirmation.vue";
import BasePrintPdf from "@shared_components/base_print_pdf.vue";
import PurchaseEdit from "@models/purchases/edit.vue";
import SaleEdit from "@models/sales/edit.vue";
import ServiceProvisionEdit from "@models/services_provision/edit.vue";
import CashInflowEdit from "@models/cash_flows/cash_inflows/edit.vue";
import CashOutflowEdit from "@models/cash_flows/cash_outflows/edit.vue";
import DepositEdit from "@models/bank_accounts/bank_account_operations/deposits/edit.vue";
import TransferEdit from "@models/bank_accounts/bank_account_operations/transfers/edit.vue";
import WithdrawEdit from "@models/bank_accounts/bank_account_operations/withdraws/edit.vue";


export default {
  data() {
    return {
      cashInflowInstallments: [],
      loading: false,
      pageLoading: false,
      totalItems: 0,
      installmentsTotalValue: 0,
      installmentsTotalPaidAmount: 0,
      tableHeaders: [
        { text: "Código", align: "left", sortable: false, value: "customCode"},
        // { text: "Origem", align: "left", sortable: false, value: "operationTypeText"},
        { text: "Origem", align: "left", sortable: false, value: "link" },
        { text: "Nº da NF-e", align: "left", sortable: false, value: "number"},
        { text: "Cliente", align: "left", sortable: true, value: "personName" },
        { text: "Plano de Contas", align: "left", sortable: true, value: "chartName" },
        { text: "Conta Bancária", align: "left", sortable: true, value: "bankAccountName" },
        { text: "Vencimento", align: "left", sortable: true, value: "dueDate" },
        { text: "Valor", align: "left", sortable: false, value: "value"},
        { text: "Recebimento", align: "left", sortable: true, value: "paymentDate" },
        { text: "Recebido", align: "left", sortable: false, value: "totalPaidAmount"},
        { text: "Status", align: "left", sortable: true, value: "status"},
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'dueDate', mask: 'date' },
        { field: 'paymentDate', mask: 'date'},
        { field: 'value', mask: 'currency' },
        { field: 'totalPaidAmount', mask: 'currency' },
        { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ],
      infoHeaders: [
        { field: 'customCode', info: 'Código da parcela é formado pelo código da conta a receber ou venda, código do recebimento e o código da parcela.' },
        { field: 'number', info: 'Número da NF-e somente para parcelas que são de vendas que possuem NF-e' },
        { field: 'value', info: 'Valor da parcela a receber (capital)' },
        { field: 'totalPaidAmount', info: 'Valor já recebido da parcela incluindo juros, multas e descontos' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Parcela de Recebimento"
    },
    modelNamePlural: {
      type: String,
      default: "Parcelas de Recebimentos"
    },
  },
  components: {
    BaseIndex: BaseIndex,    
    Edit: Edit,
    Delete: Delete,
    PaymentCancellation: PaymentCancellation,
    PaymentConfirmation: PaymentConfirmation,
    BasePrintPdf: BasePrintPdf,
    PurchaseEdit: PurchaseEdit,
    SaleEdit: SaleEdit,
    ServiceProvisionEdit: ServiceProvisionEdit,
    CashInflowEdit: CashInflowEdit,
    CashOutflowEdit: CashOutflowEdit,
    DepositEdit: DepositEdit,
    TransferEdit: TransferEdit,
    WithdrawEdit: WithdrawEdit,
  },
  created() {
    // this.loadServerEntries();
  },
  mounted() {

  },
  methods: {
    loadPdf: function(callback) {
      this.$apollo
        .query({
          query: LOAD_CASH_INFLOW_INSTALLMENTS_PDF,
          variables: {
            input: { limit: 0, offset: 0, filters: this.filters }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          const report = response.data.accountContext.cashInflowInstallmentsIndexPdf;
          callback({ pdf: report.pdf, numPages: report.numPages });
        })
        .catch(error => {
          console.log("exception aqui", error);
          this.$refs.baseIndex.showErrorMessage("Nao foi possível gerar o relatório. Tente novamente mais tarde ou contate o suporte.");
          // this.loading = false;
          // this.pageLoading = false;
          callback({ pdf: null, numPages: 0 });
        });
    },
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_CASH_INFLOW_INSTALLMENTS,
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.cashInflowInstallments = response.data.accountContext.cashInflowInstallmentsIndex.cashInflowInstallmentViewIndexFilters;
          // console.log("All cashInflowInstallments", this.cashInflowInstallments);
          this.installmentsTotalValue = response.data.accountContext.cashInflowInstallmentsIndex.installmentsTotalValue;
          this.installmentsTotalPaidAmount = response.data.accountContext.cashInflowInstallmentsIndex.installmentsTotalPaidAmount;

          this.totalItems = response.data.accountContext.cashInflowInstallmentsIndex.count;
          this.typeOperators = response.data.accountContext.cashInflowInstallmentsIndex.typeOperators;
          this.serverFields = response.data.accountContext.cashInflowInstallmentsIndex.serverFields;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      console.log("del");
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Recebimento de parcela cancelado com sucesso!");
    },
    itemClasses: function(item) {
      if (item.statusKey == "pending_payment") {
        return "pending_item";
      }
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

const LOAD_ALL_CASH_INFLOW_INSTALLMENTS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      cashInflowInstallmentsIndex(input: $input) {
        count
        installmentsTotalValue
        installmentsTotalPaidAmount
        cashInflowInstallmentViewIndexFilters{
          id
          code
          customCode
          value
          originalValue
          paidAmount
          totalPaidAmount
          dueDate
          paymentDate
          discount
          interest
          penalty
          status
          statusColor
          statusKey
          series
          number
          observation
          parentObservation
          operationTypeText
          parentType
          parentId
          parentObject
          personName
          chartName
          bankAccountName          
        }
        typeOperators
        serverFields
      }
    }
  }
`;

const LOAD_CASH_INFLOW_INSTALLMENTS_PDF = gql `
  query($input: IndexInputObject!) {
    accountContext {
      cashInflowInstallmentsIndexPdf(input: $input)
    }
  }
`;

</script>

<style scoped>
  ::v-deep .pending_item {
    color: blue;
  }
</style>
